import { render, staticRenderFns } from "./EditorCourseTreeNode.vue?vue&type=template&id=0f43617a&scoped=true"
import script from "./EditorCourseTreeNode.vue?vue&type=script&lang=js"
export * from "./EditorCourseTreeNode.vue?vue&type=script&lang=js"
import style0 from "./EditorCourseTreeNode.vue?vue&type=style&index=0&id=0f43617a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f43617a",
  null
  
)

export default component.exports